import ConsultRules from './ConsultRules';
export default ConsultRules;
